module.exports = __webpack_public_path__ + "img/id-lqtafsir-3.73e49330.webp";